// src/component/Seo/Seo.jsx
// SEO par page. React 19 hisse nativement <title>/<meta>/<link> vers le <head>.
import React from "react";

// www : seule adresse couverte par le certificat SSL (le domaine nu redirige vers www)
export const SITE_URL = "https://www.amenedistribution.tn";
const DEFAULT_IMG = SITE_URL + "/logo512.png";

export default function Seo({
  title,
  description,
  path = "",
  image = DEFAULT_IMG,
  type = "website",
  jsonLd = null,
  noindex = false,
}) {
  const url = SITE_URL + path;
  const fullTitle = title
    ? `${title} | Amen Distribution`
    : "Amen Distribution — Pièces auto & pièces de rechange B2B en Tunisie";

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Amen Distribution" />
      <meta property="og:locale" content="fr_TN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}

      {jsonLd && (
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      )}
    </>
  );
}
